import { Icons } from "assets";
import classNames from "classnames";
import styles from "./style.module.scss";
import CustomBadge from "shared/components/common/customBadge";
import CustomButton from "shared/components/common/customButton";

export interface CustomDocumentsProps {
  title?: string;
  description?: string;
  author?: string;
  date?: string;
  size?: string;
  status?: string;
  showBorder?: boolean;
  onDownload?: () => void;
  isDownloading?: boolean;
  className?: string;
}

const CustomDocuments = ({
  title,
  description,
  author,
  date,
  status,
  size,
  showBorder = true,
  onDownload,
  isDownloading = false,
  className,
  data,
}: CustomDocumentsProps & { data?: any }) => {
  const displayTitle =
    title ||
    (data
      ? typeof data.title === "number"
        ? `Revision ${data.title}.zip`
        : `${data.title}.zip`
      : "");
  const displayAuthor = author || data?.currentRevision;
  const displayDate = date || data?.nextRevisionDate;
  const displayStatus = status || data?.status;
  const displaySize = size || "";

  return (
    <div
      className={classNames(
        styles.wrapper,
        "relative flex items-center",
        showBorder && styles.leftBorder,
        className,
      )}
    >
      <span>
        <Icons.DownloadIcon2 className={styles.documentIcon} />
      </span>

      <div className={styles.content}>
        <div className="flex items-center gap-3">
          <h5 className={styles.title}>{displayTitle}</h5>
          <span className="md:static absolute right-3.5 top-3.5">
            <CustomBadge title={data?.status} statusType={displayStatus} />
          </span>
        </div>

        {description && <div className={styles.description}>{description}</div>}

        <div className={styles.meta}>
          {displayAuthor && <h6 className={styles.author}>{displayAuthor}</h6>}
          {displayAuthor && displayDate && (
            <span className={styles.separator}>•</span>
          )}
          {displayDate && <span className={styles.date}>{displayDate}</span>}
          {displayAuthor && displaySize && (
            <span className={styles.separator}>•</span>
          )}
          {displaySize && <span className={styles.size}>{displaySize}</span>}
        </div>
      </div>

      <CustomButton
        IconDirection="left"
        Icon={Icons.Download}
        title={isDownloading ? "Downloading..." : "Download"}
        containerStyle={classNames(styles.projectButton, "primary-outline-btn")}
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation();
          if (!isDownloading) {
            onDownload?.();
          }
        }}
        disabled={isDownloading}
      />
    </div>
  );
};

export default CustomDocuments;
